import { useCallback, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';

function useVideoProgress() {
  const [videoProgress, setVideoProgress] = useState({ milliseconds: 0, percents: 0 });
  const [videoSeekToValue, setVideoSeekToValue] = useState({ milliseconds: 0, percents: 0 });

  const updateVideoProgress = useCallback(state => {
    setVideoProgress(state);
  }, []);

  const updateVideoSeekToValue = useCallback(state => {
    setVideoSeekToValue(state);
  }, []);

  return useMemo(
    () => ({
      videoProgress,
      videoSeekToValue,
      updateVideoProgress,
      updateVideoSeekToValue,
    }),
    [videoProgress, videoSeekToValue]
  );
}

export const useVideoProgressContext = constate(useVideoProgress);

const VideoProgressContext = {
  Provider: useVideoProgressContext.Provider,
};

export default VideoProgressContext;
